module.exports = __webpack_public_path__ + "static/media/CL.8d08f3af.wav";